webpackJsonp([6],{

/***/ 0:
/*!******************************************!*\
  !*** ./app/pages/number-circle/index.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _rx = __webpack_require__(/*! rx */ 1);
	
	var _core = __webpack_require__(/*! @cycle/core */ 14);
	
	var _core2 = _interopRequireDefault(_core);
	
	var _isolate = __webpack_require__(/*! @cycle/isolate */ 4);
	
	var _isolate2 = _interopRequireDefault(_isolate);
	
	var _dom = __webpack_require__(/*! @cycle/dom */ 2);
	
	var _numberCircle = __webpack_require__(/*! ../../components/number-circle */ 294);
	
	var _numberCircle2 = _interopRequireDefault(_numberCircle);
	
	var _preventDefault = __webpack_require__(/*! ../../drivers/prevent-default */ 12);
	
	var _stopPropagation = __webpack_require__(/*! ../../drivers/stop-propagation */ 104);
	
	var _globalEvents = __webpack_require__(/*! ../../drivers/global-events */ 11);
	
	__webpack_require__(/*! ./index.styl */ 380);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ENCODINGS = [{
	  key: 'positive',
	  label: 'Positive'
	}, {
	  key: 'signed',
	  label: 'Sign Magnitude',
	  short: 'Sign Mag'
	}, {
	  key: 'complement1',
	  label: '1s Complement',
	  short: '1s Comp'
	}, {
	  key: 'complement2',
	  label: '2s Complement',
	  short: '2s Comp'
	}];
	
	var renderBitButtons = function renderBitButtons(state) {
	  return (0, _dom.div)('.button-bar', [
	  // The button for removing a bit
	  (0, _dom.button)('.bit-button', {
	    attributes: {
	      'data-action': 'remove-bit'
	    },
	    disabled: state.canRemoveBits ? void 0 : 'true'
	  }, 'Remove Bit'),
	
	  // The button for adding a bit
	  (0, _dom.button)('.bit-button', {
	    attributes: {
	      'data-action': 'add-bit'
	    },
	    disabled: state.canAddBits ? void 0 : 'true'
	  }, 'Add Bit')]);
	};
	
	var renderEncodingButtons = function renderEncodingButtons(state) {
	  return (0, _dom.div)('.button-bar', ENCODINGS.map(function (enc) {
	    return (0, _dom.button)('.bit-button', {
	      attributes: {
	        'data-encoding': enc.key
	      },
	      disabled: state.encoding !== enc.key ? void 0 : 'true'
	    }, enc.short ? [(0, _dom.span)('.short-label', enc.short), (0, _dom.span)('.long-label', enc.label)] : enc.label);
	  }));
	};
	
	// convert array of angles into svg
	var render = function render(state, circle) {
	  return (0, _dom.div)('.number-circle-container', [(0, _dom.div)('.number-circle-head', [(0, _dom.div)('.number-circle-head-left', [(0, _dom.div)('.bit-count', ['Number of bits: ', state.bitCount]), renderBitButtons(state)]), (0, _dom.div)('.number-circle-head-right', [(0, _dom.div)('.bit-count', ['Encoding']), renderEncodingButtons(state)])]), (0, _dom.div)('.number-circle-body', [circle])]);
	};
	
	var intent = function intent(DOM) {
	  return {
	    addBit$: DOM.select('[data-action="add-bit"]').events('click'),
	    removeBit$: DOM.select('[data-action="remove-bit"]').events('click'),
	    setEncoding$: DOM.select('[data-encoding]').events('click').map(function (evt) {
	      return evt.ownerTarget.dataset.encoding;
	    })
	  };
	};
	
	var model = function model(_ref, actions) {
	  var initialBitCount = _ref.initial,
	      maxBitCount = _ref.max;
	
	  var modifierFunction$ = _rx.Observable.merge([actions.addBit$.map(function () {
	    return function (state) {
	      return { bitCount: state.bitCount + 1, encoding: state.encoding };
	    };
	  }), actions.removeBit$.map(function () {
	    return function (state) {
	      return { bitCount: state.bitCount - 1, encoding: state.encoding };
	    };
	  }), actions.setEncoding$.map(function (encoding) {
	    return function (state) {
	      return { bitCount: state.bitCount, encoding: encoding };
	    };
	  })]).share();
	
	  return modifierFunction$
	  // number of bits to generate the number circle for
	  .startWith({ bitCount: initialBitCount, encoding: 'positive' })
	  // apply the function
	  .scan(function (state, modifierFunction) {
	    return modifierFunction(state);
	  })
	  // convert number of bit's into array of angles
	  .map(function (_ref2) {
	    var bitCount = _ref2.bitCount,
	        encoding = _ref2.encoding;
	    return {
	      // number of bits
	      bitCount: bitCount,
	      // the encoding to interpret the bit pattern
	      encoding: encoding,
	      // boolean if more bits can be added
	      canAddBits: bitCount < maxBitCount,
	      // boolean if a bit can be removed
	      canRemoveBits: bitCount > 1
	    };
	  });
	};
	
	var view = function view(state$, circle$) {
	  return _rx.Observable.combineLatest(state$, circle$, render);
	};
	
	var numberCircleApp = function numberCircleApp(sources) {
	  var DOM = sources.DOM,
	      globalEvents = sources.globalEvents;
	
	
	  var actions = intent(sources.DOM);
	  var state$ = model({ initial: 3, max: 7 }, actions);
	
	  var circle = (0, _isolate2.default)(_numberCircle2.default, 'circle')({
	    DOM: DOM,
	    globalEvents: globalEvents,
	    bitCount$: state$.map(function (s) {
	      return s.bitCount;
	    }),
	    encoding$: state$.map(function (s) {
	      return s.encoding;
	    })
	  });
	
	  var vtree$ = view(state$, circle.DOM);
	
	  return {
	    DOM: vtree$,
	    preventDefault: circle.preventDefault,
	    stopPropagation: circle.stopPropagation
	  };
	};
	
	var drivers = {
	  DOM: (0, _dom.makeDOMDriver)('#app'),
	  preventDefault: _preventDefault.preventDefaultDriver,
	  stopPropagation: _stopPropagation.stopPropagationDriver,
	  globalEvents: _globalEvents.globalEventDriver
	};
	
	_core2.default.run(numberCircleApp, drivers);

/***/ },

/***/ 5:
/*!*******************************!*\
  !*** ./app/lib/dom-helper.js ***!
  \*******************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.wrapInDiv = undefined;
	
	var _dom = __webpack_require__(/*! @cycle/dom */ 2);
	
	var wrapInDiv = exports.wrapInDiv = function wrapInDiv(node) {
	  return (0, _dom.div)(node);
	};

/***/ },

/***/ 6:
/*!**************************!*\
  !*** ./app/lib/utils.js ***!
  \**************************/
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This file contains utility functions
	 */
	
	// wrap the given function to memoize return values
	// for simple parameters
	var memoize = exports.memoize = function memoize(func) {
	  var map = {};
	
	  return function (p) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    // do not memoze complex parameters
	    if (args.length > 0 || typeof p !== 'string' && typeof p !== 'number') {
	      return func.apply(undefined, [p].concat(args));
	    }if (!map.hasOwnProperty()) {
	      var val = map[p] = func(p);
	      return val;
	    } else {
	      return map[p];
	    }
	  };
	};
	
	// get a function the returns a property
	// of the object it get's passed as argument.
	var pluck = exports.pluck = function pluck(key) {
	  return function (obj) {
	    return obj[key];
	  };
	};
	
	// if value < min return min
	// if value > max return max
	// otherwise return value
	var clamp = exports.clamp = function clamp(value, min, max) {
	  return Math.min(Math.max(value, min), max);
	};
	
	// get a string of given width
	// by prepending pad to base
	var padLeft = exports.padLeft = function padLeft(base, width, pad) {
	  return Array(width - String(base).length + 1).join(pad) + base;
	};
	
	// compose multiple functions to a single one
	// compose(a,b,c)(x) === c(b(a(x)))
	var compose = exports.compose = function compose() {
	  for (var _len2 = arguments.length, functions = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    functions[_key2] = arguments[_key2];
	  }
	
	  return function (arg) {
	    return functions.reduce(function (acc, fn) {
	      return fn(acc);
	    }, arg);
	  };
	};

/***/ },

/***/ 7:
/*!*****************************!*\
  !*** ./app/lib/h-helper.js ***!
  \*****************************/
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// "if" defined as a function to be used as expression
	//
	// condition - a boolean values
	// fn - a function which return value is returned if
	//      condition is truthy
	//
	// returns void if condition is falsy
	var IF = exports.IF = function IF(condition, fn) {
	  if (condition) {
	    return fn();
	  } else {
	    return void 0;
	  }
	};
	
	// convert falsy values to void
	var attrBool = exports.attrBool = function attrBool(condition) {
	  if (condition) {
	    return condition;
	  } else {
	    return void 0;
	  }
	};

/***/ },

/***/ 11:
/*!**************************************!*\
  !*** ./app/drivers/global-events.js ***!
  \**************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.globalEventDriver = undefined;
	
	var _rx = __webpack_require__(/*! rx */ 1);
	
	// This driver captures global events
	// and provides them as Observable
	var globalEventDriver = exports.globalEventDriver = function globalEventDriver() {
	  return {
	    events: function events(eventName) {
	      return _rx.Observable.fromEventPattern(function (h) {
	        document.addEventListener(eventName, h, true);
	      }, function (h) {
	        document.removeEventListener(eventName, h, true);
	      });
	    }
	  };
	};

/***/ },

/***/ 12:
/*!****************************************!*\
  !*** ./app/drivers/prevent-default.js ***!
  \****************************************/
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// This driver consumes an Observable of dom event objects
	// and cancels their default behavior
	var preventDefaultDriver = exports.preventDefaultDriver = function preventDefaultDriver(event$) {
	  event$.subscribe(function (evt) {
	    evt.preventDefault();
	  });
	
	  return Object.create(null);
	};

/***/ },

/***/ 29:
/*!******************************************!*\
  !*** ./app/components/graphics/index.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rx = __webpack_require__(/*! rx */ 1);
	
	var _model = __webpack_require__(/*! ./model */ 32);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _view = __webpack_require__(/*! ./view */ 33);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _intent = __webpack_require__(/*! ./intent */ 31);
	
	var _intent2 = _interopRequireDefault(_intent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// initialize the graphics component
	exports.default = function (_ref) {
	  var _O$just;
	
	  var DOM = _ref.DOM,
	      globalEvents = _ref.globalEvents,
	      _ref$props$ = _ref.props$,
	      props$ = _ref$props$ === undefined ? _rx.Observable.just({
	    width: 500, // The width of the SVG element
	    height: 500 }) : _ref$props$,
	      _ref$camera$ = _ref.camera$,
	      camera$ = _ref$camera$ === undefined ? _rx.Observable.just({ // The initial camera position
	    x: 0, // position on the x axis
	    y: 0, // position on the y axis
	    zoom: 1 }) : _ref$camera$,
	      _ref$bounds$ = _ref.bounds$,
	      bounds$ = _ref$bounds$ === undefined ? _rx.Observable.just((_O$just = { // The bounding box of the scene.
	    // The camera can not be moved outside this box
	    minX: 0,
	    maxX: 0
	  }, _defineProperty(_O$just, 'minX', 0), _defineProperty(_O$just, 'maxX', 0), _O$just)) : _ref$bounds$,
	      content$ = _ref.content$,
	      _ref$autoCenter$ = _ref.autoCenter$,
	      autoCenter$ = _ref$autoCenter$ === undefined ? _rx.Observable.just(null) : _ref$autoCenter$;
	
	  var actions = (0, _intent2.default)(DOM, globalEvents);
	  var state$ = (0, _model2.default)({
	    props$: props$, camera$: camera$, bounds$: bounds$, content$: content$, autoCenter$: autoCenter$
	  }, actions);
	  var vtree$ = (0, _view2.default)(state$);
	
	  return {
	    DOM: vtree$,
	    preventDefault: actions.preventDefault
	  };
	};

/***/ },

/***/ 30:
/*!****************************************************!*\
  !*** ./app/components/graphics/intent/gestures.js ***!
  \****************************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pan = exports.zoom = undefined;
	
	var _rx = __webpack_require__(/*! rx */ 1);
	
	var _immutable = __webpack_require__(/*! immutable */ 3);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This file contains the logic for recognizing
	// pan and pinch gestures from touch events.
	
	var ownerElement = function ownerElement(rootElement) {
	  return rootElement.observable.map(function (e) {
	    return e[0];
	  }).distinctUntilChanged(function (e) {
	    return e;
	  }, function (a, b) {
	    return a === b;
	  }).shareReplay(1);
	};
	
	// get the id of the given touch
	var touchId = function touchId(touch) {
	  return touch.identifier;
	};
	
	// http://stackoverflow.com/a/12737882/1533291
	var isPrimaryMouseButton = function isPrimaryMouseButton(event) {
	  if ('buttons' in event) {
	    return event.buttons === 1;
	  } else if ('which' in event) {
	    return event.which === 1;
	  } else {
	    return event.button === 1;
	  }
	};
	
	// get a stream of current touch ids
	var toucheIds = function toucheIds(globalEvents, rootElement) {
	  return _rx.Observable.merge([rootElement.events('touchstart').map(function (e) {
	    return function (ids) {
	      return ids.union(Array.prototype.map.call(e.changedTouches, touchId));
	    };
	  }), globalEvents.events('touchend').map(function (e) {
	    return function (ids) {
	      return ids.subtract(Array.prototype.map.call(e.changedTouches, touchId));
	    };
	  })]).scan(function (ids, modFn) {
	    return modFn(ids);
	  }, _immutable2.default.Set()).distinctUntilChanged(function (e) {
	    return e;
	  }, function (a, b) {
	    return a === b;
	  }).share();
	};
	
	// get the center point of the given touches
	var touchCenter = function touchCenter(touches) {
	  var length = touches.length;
	  var center = Array.prototype.reduce.call(touches, function (sum, touch) {
	    return {
	      x: sum.x + touch.pageX / length,
	      y: sum.y + touch.pageY / length
	    };
	  }, { x: 0, y: 0 });
	
	  return center;
	};
	
	// get the avarage radius of the touches around their center
	var touchRadius = function touchRadius(touches) {
	  var length = touches.length;
	
	  var _touchCenter = touchCenter(touches),
	      x = _touchCenter.x,
	      y = _touchCenter.y;
	
	  return touches.reduce(function (sum, touch) {
	    return sum + Math.sqrt(Math.pow(touch.pageX - x, 2) + Math.pow(touch.pageY - y, 2));
	  }, 0) / length;
	};
	
	// Return only the touches with the given ids.
	var filterTouches = function filterTouches(ids, touches) {
	  return Array.prototype.filter.call(touches, function (touch) {
	    return ids.contains(touch.identifier);
	  });
	};
	
	// get the zoom factor for the given wheel event
	var wheelFactor = function wheelFactor(wheelEvent) {
	  var wheel = wheelEvent.deltaY / -40;
	  return Math.pow(1 + Math.abs(wheel) / 2, wheel > 0 ? 1 : -1);
	};
	
	// transforms touch event streams into a pinch action stream
	var touchZoom = function touchZoom(_ref) {
	  var pinchStart$ = _ref.pinchStart$,
	      pinchMove$ = _ref.pinchMove$,
	      pinchEnd$ = _ref.pinchEnd$,
	      owner$ = _ref.owner$,
	      positionFn = _ref.positionFn;
	  return pinchStart$.map(function (ids) {
	    return pinchMove$.withLatestFrom(owner$, function (moveEvt, owner) {
	      var touches = filterTouches(ids, moveEvt.touches);
	
	      var _positionFn = positionFn(touchCenter(touches), owner),
	          x = _positionFn.x,
	          y = _positionFn.y;
	
	      return {
	        distance: touchRadius(touches),
	        pivot: { x: x, y: y },
	        factor: 1
	      };
	    }).scan(function (prev, current) {
	      return {
	        pivot: current.pivot,
	        distance: current.distance,
	        factor: current.distance / prev.distance
	      };
	    }).takeUntil(pinchEnd$).share();
	  }).switch();
	};
	
	// transforms mouse wheel events into pinch/zoom events
	var wheelZoom = function wheelZoom(_ref2) {
	  var wheel$ = _ref2.wheel$,
	      owner$ = _ref2.owner$,
	      positionFn = _ref2.positionFn;
	  return wheel$.withLatestFrom(owner$, function (evt, owner) {
	    var pivot = positionFn({
	      x: evt.pageX,
	      y: evt.pageY
	    }, owner);
	
	    var factor = wheelFactor(evt);
	
	    return {
	      factor: factor,
	      pivot: pivot
	    };
	  }).share();
	};
	
	// interpret drag and touch events as pinch/zoom
	//
	// returns {action$, stopPropagation, preventDefault}
	// action$ - a stream containing the pinch/zoom gestures
	// stopPropagation - a stream containing the processed events
	// preventDefault - a stream containing the event's that default
	//                  behavior should be canceled
	var zoom = exports.zoom = function zoom(globalEvents, // the globalEvent driver source
	rootElement, // DOM source on which the pinch/zoom should be recognized
	positionFn // function translation event positions
	// into world coordinate system
	) {
	  var owner$ = ownerElement(rootElement);
	
	  var touches$ = toucheIds(globalEvents, rootElement);
	  var pinchStart$ = touches$.filter(function (ids) {
	    return ids.size >= 2;
	  });
	  var pinchEnd$ = touches$.filter(function (ids) {
	    return ids.size < 2;
	  });
	
	  var wheel$ = rootElement.events('wheel').filter(function (evt) {
	    return !evt.altKey;
	  }).share();
	
	  var pinchMove$ = globalEvents.events('touchmove');
	
	  var touchAction$ = touchZoom({
	    pinchStart$: pinchStart$, pinchMove$: pinchMove$, pinchEnd$: pinchEnd$,
	    owner$: owner$, positionFn: positionFn
	  });
	
	  var wheelAction$ = wheelZoom({ wheel$: wheel$, owner$: owner$, positionFn: positionFn });
	
	  return {
	    action$: _rx.Observable.merge([touchAction$, wheelAction$]).share(),
	    stopPropagation: _rx.Observable.empty(),
	    preventDefault: wheel$
	  };
	};
	
	// transforms touch event streams into a panning action stream
	var touchPan = function touchPan(_ref3) {
	  var touchChange$ = _ref3.touchChange$,
	      panStart$ = _ref3.panStart$,
	      panMove$ = _ref3.panMove$,
	      panEnd$ = _ref3.panEnd$,
	      owner$ = _ref3.owner$,
	      positionFn = _ref3.positionFn;
	  return panStart$.withLatestFrom(touchChange$, owner$, function (ids, initial, owner) {
	    var _positionFn2 = positionFn(touchCenter(filterTouches(ids, initial.touches)), owner),
	        startX = _positionFn2.x,
	        startY = _positionFn2.y;
	
	    return panMove$.map(function (move) {
	      return positionFn(touchCenter(filterTouches(ids, move.touches)), owner);
	    }).map(function (target) {
	      return {
	        x: target.x - startX,
	        y: target.y - startY
	      };
	    }).takeUntil(panEnd$).share();
	  }).switch();
	};
	
	var mousePan = function mousePan(_ref4) {
	  var mouseDown$ = _ref4.mouseDown$,
	      mouseMove$ = _ref4.mouseMove$,
	      mouseUp$ = _ref4.mouseUp$,
	      owner$ = _ref4.owner$,
	      positionFn = _ref4.positionFn;
	  return mouseDown$.withLatestFrom(owner$, function (downEvt, owner) {
	    var _positionFn3 = positionFn({ x: downEvt.pageX, y: downEvt.pageY }, owner),
	        startX = _positionFn3.x,
	        startY = _positionFn3.y;
	
	    return mouseMove$.map(function (move) {
	      return positionFn({ x: move.pageX, y: move.pageY }, owner);
	    }).map(function (target) {
	      return {
	        x: target.x - startX,
	        y: target.y - startY
	      };
	    }).takeUntil(mouseUp$).share();
	  }).switch();
	};
	
	// interpret drag and touch events as panning
	//
	// returns {action$, stopPropagation, preventDefault}
	// action$ - a stream containing the pan gestures
	// stopPropagation - a stream containing the processed events
	// preventDefault - a stream containing the event's that default
	//                  behavior should be canceled
	var pan = exports.pan = function pan(globalEvents, // the globalEvent driver source
	rootElement, // DOM source on which the panning should be recognized
	positionFn // function translation event positions
	// into world coordinate system
	) {
	  var owner$ = ownerElement(rootElement);
	
	  var touchChange$ = _rx.Observable.merge([rootElement.events('touchstart'), globalEvents.events('touchend')]).share();
	
	  var touches$ = toucheIds(globalEvents, rootElement);
	  var panStart$ = touches$.filter(function (ids) {
	    return ids.size > 0;
	  });
	  var panEnd$ = touches$.filter(function (ids) {
	    return ids.size <= 0;
	  });
	  var panMove$ = globalEvents.events('touchmove');
	
	  var mouseDown$ = rootElement.events('mousedown').filter(isPrimaryMouseButton);
	  var mouseMove$ = globalEvents.events('mousemove');
	  var mouseUp$ = globalEvents.events('mouseup');
	
	  var touchAction$ = touchPan({
	    touchChange$: touchChange$, panStart$: panStart$, panMove$: panMove$, panEnd$: panEnd$, owner$: owner$, positionFn: positionFn
	  });
	
	  var mouseAction$ = mousePan({
	    mouseDown$: mouseDown$, mouseMove$: mouseMove$, mouseUp$: mouseUp$, owner$: owner$, positionFn: positionFn
	  });
	
	  var preventDefault = _rx.Observable.merge([panStart$.map(function () {
	    return panMove$.takeUntil(panEnd$);
	  }).switch(), mouseDown$.map(function () {
	    return mouseMove$.takeUntil(mouseUp$);
	  }).switch()]).share();
	
	  return {
	    action$: _rx.Observable.merge([touchAction$, mouseAction$]).share(),
	    stopPropagation: _rx.Observable.empty(),
	    preventDefault: preventDefault
	  };
	};

/***/ },

/***/ 31:
/*!*************************************************!*\
  !*** ./app/components/graphics/intent/index.js ***!
  \*************************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rx = __webpack_require__(/*! rx */ 1);
	
	var _gestures = __webpack_require__(/*! ./gestures */ 30);
	
	var svgEventPosition = function () {
	  var oldPoint = null;
	  // a function transforming a given point into the coordinate
	  // system of the given svg element
	  return function (_ref, svg) {
	    var x = _ref.x,
	        y = _ref.y;
	
	    var pt = oldPoint || (oldPoint = svg.createSVGPoint());
	    pt.x = x;
	    pt.y = y;
	    var result = pt.matrixTransform(svg.getScreenCTM().inverse());
	    return result;
	  };
	}();
	
	exports.default = function (DOM, globalEvents) {
	  var rootElement = DOM.select('.graphics-root');
	
	  var panAction = (0, _gestures.pan)(globalEvents, rootElement, svgEventPosition);
	  var zoomAction = (0, _gestures.zoom)(globalEvents, rootElement, svgEventPosition);
	
	  return {
	    zoom$: zoomAction.action$,
	    pan$: panAction.action$,
	    preventDefault: _rx.Observable.merge([zoomAction.preventDefault, panAction.preventDefault]).share(),
	    stopPropagation: _rx.Observable.merge([zoomAction.stopPropagation, panAction.stopPropagation]).share()
	  };
	};

/***/ },

/***/ 32:
/*!************************************************!*\
  !*** ./app/components/graphics/model/index.js ***!
  \************************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rx = __webpack_require__(/*! rx */ 1);
	
	var _utils = __webpack_require__(/*! ../../../lib/utils */ 6);
	
	var _contentThunk = __webpack_require__(/*! ../../../lib/contentThunk */ 41);
	
	// create a function the zooms a camera state {x,y,zoom}
	// by a factor round a pivot point {x, y}.
	//
	// the camera position is clamped to stay inside the bounds
	// the zoom level is clamped to stay between the zoomLimit.
	var zoomModifier = function zoomModifier(_ref, zoomLimit, bounds) {
	  var factor = _ref.factor,
	      _ref$pivot = _ref.pivot,
	      pivotX = _ref$pivot.x,
	      pivotY = _ref$pivot.y;
	  return function (_ref2) {
	    var x = _ref2.x,
	        y = _ref2.y,
	        zoom = _ref2.zoom;
	
	    var newZoom = (0, _utils.clamp)(zoom * factor, zoomLimit.min, zoomLimit.max);
	    var realFactor = newZoom / zoom;
	    var panFactor = 1 - 1 / realFactor;
	
	    return {
	      zoom: newZoom,
	      x: (0, _utils.clamp)(x + (pivotX - x) * panFactor, bounds.minX, bounds.maxX),
	      y: (0, _utils.clamp)(y + (pivotY - y) * panFactor, bounds.minY, bounds.maxY)
	    };
	  };
	};
	
	// create a function the transforms a camera state {x, y, zoom}
	// by a delta {x, y}.
	//
	// the camera position is clamped to stay inside the bounds
	// the zoom level is clamped to stay between the zoomLimit.
	var panModifier = function panModifier(delta, bounds) {
	  return function (_ref3) {
	    var x = _ref3.x,
	        y = _ref3.y,
	        zoom = _ref3.zoom;
	    return {
	      zoom: zoom,
	      x: (0, _utils.clamp)(x - delta.x, bounds.minX, bounds.maxX),
	      y: (0, _utils.clamp)(y - delta.y, bounds.minY, bounds.maxY)
	    };
	  };
	};
	
	// create a function the aligns a camera state {x, y, zoom}
	// relative to a bounding box.
	//
	// weightX and weightY are number controling the camera alignment
	// relative to the bounding box:
	// 0.0:    align left/top border of the camera to left/top side of bounding
	// 0.5: center cemera
	// 1.0:   align right/bottom border of the camera to the
	//      right/bottom side of the bounding
	//
	// the camera position is clamped to stay inside the bounds
	// the zoom level is clamped to stay between the zoomLimit.
	//
	// width and height are the size of the stage.
	var autoCenterModifier = function autoCenterModifier(_ref4, zoomLimit, bounds, _ref5) {
	  var _ref4$weightX = _ref4.weightX,
	      weightX = _ref4$weightX === undefined ? 0.5 : _ref4$weightX,
	      _ref4$weightY = _ref4.weightY,
	      weightY = _ref4$weightY === undefined ? 0 : _ref4$weightY;
	  var width = _ref5.width,
	      height = _ref5.height;
	
	  var centerX = (bounds.maxX + bounds.minX) / 2;
	  var centerY = (bounds.maxY + bounds.minY) / 2;
	  var contentWidth = bounds.maxX - bounds.minX;
	  var contentHeight = bounds.maxY - bounds.minY;
	  var xRatio = (width - 20) / contentWidth;
	  var zoom = xRatio;
	
	  return function () {
	    return {
	      x: (0, _utils.clamp)(centerX + (weightX - 0.5) * contentWidth, bounds.minX, bounds.maxX),
	      y: (0, _utils.clamp)(height / zoom / 2 + centerY + (weightY - 0.5) * contentHeight, bounds.minY, bounds.maxY),
	      zoom: (0, _utils.clamp)(zoom, zoomLimit.min, zoomLimit.max)
	    };
	  };
	};
	
	exports.default = function (_ref6, actions) {
	  var props$ = _ref6.props$,
	      camera$ = _ref6.camera$,
	      bounds$ = _ref6.bounds$,
	      content$ = _ref6.content$,
	      autoCenter$ = _ref6.autoCenter$;
	
	  // wrap the content stream in a thunk object
	  // to prevent redundant virtual-dom diff calculations
	  // (performance)
	  var cachedContent$ = content$.map(function (content, index) {
	    return new _contentThunk.ContentThunk(content, index % 2);
	  });
	
	  return _rx.Observable.combineLatest(props$, camera$, function (props, initCamera) {
	    // the zoom limits depend on the relation of
	    // bounds (size of the content) and the width/height props
	    // (size of the stage)
	    // so it's always possible to zoom out to see the whole content
	    var zoomLimit$ = bounds$.map(function (bounds) {
	      return {
	        min: Math.min(props.width / (bounds.maxX - bounds.minX), props.height / (bounds.maxY - bounds.minY), 0.5),
	        // upper zoom limit is currently just to a constant value
	        // TODO(Laszlo Korte): come up with a sensible relationship?
	        max: 5
	      };
	    });
	
	    return _rx.Observable.merge([actions.zoom$.withLatestFrom(zoomLimit$, bounds$, zoomModifier), actions.pan$.withLatestFrom(bounds$, panModifier), autoCenter$.withLatestFrom(zoomLimit$, bounds$, props$, autoCenterModifier)]).startWith({
	      zoom: initCamera.zoom,
	      x: initCamera.x,
	      y: initCamera.y
	    }).scan(function (cam, modFn) {
	      return modFn(cam);
	    }).combineLatest(bounds$, cachedContent$, function (cam, bounds, content) {
	      return {
	        width: props.width,
	        height: props.height,
	        camera: cam,
	        bounds: bounds,
	        content: content
	      };
	    });
	  }).switch().shareReplay(1);
	};

/***/ },

/***/ 33:
/*!***********************************************!*\
  !*** ./app/components/graphics/view/index.js ***!
  \***********************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dom = __webpack_require__(/*! @cycle/dom */ 2);
	
	__webpack_require__(/*! ./index.styl */ 46);
	
	// create the viewbox string
	var viewbox = function viewbox(width, height, camera) {
	  return camera.x - width / 2 / camera.zoom + '\n   ' + (camera.y - height / 2 / camera.zoom) + '\n   ' + width / camera.zoom + '\n   ' + height / camera.zoom;
	};
	
	// create a rectangle covering the whole element
	var renderBackground = function renderBackground(width, height, camera) {
	  return (0, _dom.svg)('rect', {
	    attributes: {
	      x: ~~(0.5 + camera.x - width / camera.zoom / 2),
	      y: ~~(0.5 + camera.y - height / camera.zoom / 2),
	      width: ~~(0.5 + width / camera.zoom),
	      height: ~~(0.5 + height / camera.zoom),
	      class: 'graphics-background'
	    }
	  });
	};
	
	// create a rectange of size of the bounds
	var renderBounds = function renderBounds(_ref) {
	  var minX = _ref.minX,
	      maxX = _ref.maxX,
	      minY = _ref.minY,
	      maxY = _ref.maxY;
	  return (0, _dom.svg)('rect', {
	    attributes: {
	      x: ~~(0.5 + minX),
	      y: ~~(0.5 + minY),
	      width: ~~(0.5 + maxX - minX),
	      height: ~~(0.5 + maxY - minY),
	      class: 'graphics-camera-bounds'
	    }
	  });
	};
	
	// create the background grid
	var renderGrid = function renderGrid(_ref2) {
	  var minX = _ref2.minX,
	      maxX = _ref2.maxX,
	      minY = _ref2.minY,
	      maxY = _ref2.maxY;
	  return [(0, _dom.svg)('defs', [(0, _dom.svg)('pattern', {
	    attributes: {
	      id: 'smallGrid',
	      width: '10',
	      height: '10',
	      patternUnits: 'userSpaceOnUse'
	    }
	  }, [(0, _dom.svg)('path', {
	    attributes: {
	      d: 'M 10 0 L 0 0 0 10',
	      class: 'graphics-grid graphics-grid-small'
	    }
	  })]), (0, _dom.svg)('pattern', {
	    attributes: {
	      id: 'grid',
	      width: '100',
	      height: '100',
	      patternUnits: 'userSpaceOnUse'
	    }
	  }, [(0, _dom.svg)('rect', {
	    attributes: {
	      width: '100',
	      height: '100',
	      fill: 'url(#smallGrid)'
	    }
	  }), (0, _dom.svg)('path', {
	    attributes: {
	      d: 'M 100 0 L 0 0 0 100',
	      class: 'graphics-grid graphics-grid-large'
	    }
	  })])]), (0, _dom.svg)('rect', {
	    attributes: {
	      x: ~~(0.5 + minX),
	      y: ~~(0.5 + minY),
	      width: ~~(0.5 + maxX - minX),
	      height: ~~(0.5 + maxY - minY),
	      class: 'graphics-grid-container',
	      fill: 'url(#grid)'
	    }
	  })];
	};
	
	// create the graphics container
	var render = function render(_ref3) {
	  var width = _ref3.width,
	      height = _ref3.height,
	      camera = _ref3.camera,
	      bounds = _ref3.bounds,
	      content = _ref3.content;
	  return (0, _dom.div)('.graphics-container', [(0, _dom.svg)('svg', {
	    attributes: {
	      width: ~~(0.5 + width),
	      height: ~~(0.5 + height),
	      class: 'graphics-root',
	      viewBox: viewbox(width, height, camera),
	      preserveAspectRatio: 'xMidYMin meet'
	    }
	  }, [renderBackground(width, height, camera), renderBounds(bounds), renderGrid(bounds), (0, _dom.svg)('g', { attributes: { class: 'graphics-content' } }, content)])]);
	};
	
	exports.default = function (state$) {
	  return state$.map(render);
	};

/***/ },

/***/ 41:
/*!*********************************!*\
  !*** ./app/lib/contentThunk.js ***!
  \*********************************/
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// The constructor for simple virtual-dom Thunk object
	// prevents DOM updates of child nodes until the cache key
	// changes
	var ContentThunk = exports.ContentThunk = function thunkConstructor(node, key) {
	  this.node = node;
	  this.key = key;
	};
	
	ContentThunk.prototype.type = "Thunk";
	
	ContentThunk.prototype.render = function thunkRender(previous) {
	  if (!previous || previous.key !== this.key) {
	    return this.node;
	  } else {
	    return previous.vnode;
	  }
	};

/***/ },

/***/ 46:
/*!*************************************************!*\
  !*** ./app/components/graphics/view/index.styl ***!
  \*************************************************/
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 104:
/*!*****************************************!*\
  !*** ./app/drivers/stop-propagation.js ***!
  \*****************************************/
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// This driver consumes an Observable of dom event objects
	// and stops their propagation through the dom tree
	var stopPropagationDriver = exports.stopPropagationDriver = function stopPropagationDriver(event$) {
	  event$.subscribe(function (evt) {
	    evt.stopPropagation();
	  });
	
	  return Object.create(null);
	};

/***/ },

/***/ 294:
/*!***********************************************!*\
  !*** ./app/components/number-circle/index.js ***!
  \***********************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rx = __webpack_require__(/*! rx */ 1);
	
	var _isolate = __webpack_require__(/*! @cycle/isolate */ 4);
	
	var _isolate2 = _interopRequireDefault(_isolate);
	
	var _domHelper = __webpack_require__(/*! ../../lib/dom-helper */ 5);
	
	var _graphics = __webpack_require__(/*! ../graphics */ 29);
	
	var _graphics2 = _interopRequireDefault(_graphics);
	
	var _intent = __webpack_require__(/*! ./intent */ 295);
	
	var _intent2 = _interopRequireDefault(_intent);
	
	var _model = __webpack_require__(/*! ./model */ 297);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _view = __webpack_require__(/*! ./view */ 298);
	
	var _view2 = _interopRequireDefault(_view);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// initialize the number circle component
	exports.default = function (_ref) {
	  var DOM = _ref.DOM,
	      globalEvents = _ref.globalEvents,
	      _ref$bitCount$ = _ref.bitCount$,
	      bitCount$ = _ref$bitCount$ === undefined ? _rx.Observable.just(3) : _ref$bitCount$,
	      _ref$encoding$ = _ref.encoding$,
	      encoding$ = _ref$encoding$ === undefined ? _rx.Observable.just('signed') : _ref$encoding$;
	  var isolateSource = DOM.isolateSource,
	      isolateSink = DOM.isolateSink;
	
	
	  var actions = (0, _intent2.default)(isolateSource(DOM, 'graphicsContent'));
	  var state$ = (0, _model2.default)(encoding$, bitCount$, actions);
	  var vtree$ = (0, _view2.default)(state$);
	
	  var stage = (0, _isolate2.default)(_graphics2.default, 'mygraphics')({
	    DOM: DOM,
	    globalEvents: globalEvents,
	    props$: _rx.Observable.just({
	      width: 600,
	      height: 600
	    }),
	    camera$: _rx.Observable.just({ x: 0, y: 0, zoom: 1 }),
	    bounds$: state$.map(function (s) {
	      return s.bounds;
	    }),
	    autoCenter$: state$.map(function (s) {
	      return s.bounds;
	    }).distinctUntilChanged().map(function () {
	      return true;
	    }),
	    content$: isolateSink(vtree$, 'graphicsContent')
	  });
	
	  return {
	    DOM: stage.DOM.map(_domHelper.wrapInDiv),
	    preventDefault: _rx.Observable.merge([actions.preventDefault, stage.preventDefault]),
	    stopPropagation: actions.stopPropagation
	  };
	};

/***/ },

/***/ 295:
/*!******************************************************!*\
  !*** ./app/components/number-circle/intent/index.js ***!
  \******************************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rx = __webpack_require__(/*! rx */ 1);
	
	exports.default = function (DOM) {
	  var dot = DOM.select('[data-dot-index]');
	  var dotClick$ = dot.events('mousedown', { useCapture: true }).share();
	
	  return {
	    selectBit$: dotClick$.map(function (evt) {
	      return parseInt(evt.ownerTarget.getAttribute('data-dot-index'), 10);
	    }),
	
	    preventDefault: _rx.Observable.empty(),
	    stopPropagation: dotClick$
	  };
	};

/***/ },

/***/ 296:
/*!*********************************************************!*\
  !*** ./app/components/number-circle/model/encodings.js ***!
  \*********************************************************/
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  positive: {
	    negativeClockwise: false,
	    formatter: function formatter(pattern) {
	      return parseInt(pattern, 2).toString(10);
	    },
	    overflowAngles: function overflowAngles(dots) {
	      return [2 * Math.PI - (dots[0].angle + dots[1].angle) / 2];
	    },
	    warningAngles: function warningAngles() {
	      return [];
	    },
	    baseIndex: function baseIndex() {
	      return 0;
	    },
	    magnitude: function magnitude(pattern) {
	      return parseInt(pattern, 2) / Math.pow(2, pattern.length);
	    }
	  },
	
	  signed: {
	    negativeClockwise: true,
	    formatter: function formatter(pattern) {
	      var sign = pattern.substr(0, 1) === '1' ? '-' : '';
	
	      var num = parseInt(pattern.substr(1), 2) || 0;
	
	      return sign + num.toString(10);
	    },
	    overflowAngles: function overflowAngles(dots) {
	      return [Math.PI - (dots[0].angle + dots[1].angle) / 2, 2 * Math.PI - (dots[0].angle + dots[1].angle) / 2];
	    },
	    warningAngles: function warningAngles() {
	      return [];
	    },
	    baseIndex: function baseIndex(pattern) {
	      if (pattern.substr(0, 1) === '1') {
	        return Math.pow(2, pattern.length - 1);
	      } else {
	        return 0;
	      }
	    },
	    magnitude: function magnitude(pattern) {
	      return parseInt(pattern.substr(1) || '0', 2) / Math.pow(2, pattern.length - 1);
	    }
	  },
	
	  complement1: {
	    negativeClockwise: false,
	    formatter: function formatter(pattern) {
	      var negative = pattern.substr(0, 1) === '1';
	      var offset = negative ? -Math.pow(2, pattern.length - 1) + 1 : 0;
	
	      var num = parseInt(pattern.substr(1), 2) || 0;
	
	      return ((negative ? '-' : '') + Math.abs(offset + num)).toString(10);
	    },
	    overflowAngles: function overflowAngles(dots) {
	      var half = (dots.length - 1) / 2;
	      return [(dots[Math.floor(half)].angle + dots[Math.ceil(half)].angle) / 2];
	    },
	    warningAngles: function warningAngles(dots) {
	      return [2 * Math.PI - (dots[0].angle + dots[1].angle) / 2];
	    },
	    baseIndex: function baseIndex(pattern) {
	      if (pattern.substr(0, 1) === '1') {
	        return Math.pow(2, pattern.length) - 1;
	      } else {
	        return 0;
	      }
	    },
	    magnitude: function magnitude(pattern) {
	      var negative = pattern.substr(0, 1) === '1';
	      var offset = negative ? -Math.pow(2, pattern.length - 1) + 1 : 0;
	
	      var num = parseInt(pattern.substr(1), 2) || 0;
	
	      return Math.abs(offset + num) / Math.pow(2, pattern.length - 1);
	    }
	  },
	
	  complement2: {
	    negativeClockwise: false,
	    formatter: function formatter(pattern) {
	      var offset = pattern.substr(0, 1) === '1' ? -Math.pow(2, pattern.length - 1) : 0;
	
	      var num = parseInt(pattern.substr(1), 2) || 0;
	
	      return (offset + num).toString(10);
	    },
	    overflowAngles: function overflowAngles(dots) {
	      var half = (dots.length - 1) / 2;
	      return [(dots[Math.floor(half)].angle + dots[Math.ceil(half)].angle) / 2];
	    },
	    warningAngles: function warningAngles() {
	      return [];
	    },
	    baseIndex: function baseIndex() {
	      return 0;
	    },
	    magnitude: function magnitude(pattern) {
	      var offset = pattern.substr(0, 1) === '1' ? -Math.pow(2, pattern.length - 1) : 0;
	
	      var num = parseInt(pattern.substr(1), 2) || 0;
	
	      return Math.abs(offset + num) / Math.pow(2, pattern.length - 1);
	    }
	  }
	};

/***/ },

/***/ 297:
/*!*****************************************************!*\
  !*** ./app/components/number-circle/model/index.js ***!
  \*****************************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rx = __webpack_require__(/*! rx */ 1);
	
	var _encodings = __webpack_require__(/*! ./encodings */ 296);
	
	var _encodings2 = _interopRequireDefault(_encodings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// convert numbert into bit pattern string of length
	// bitCount.
	var bitPattern = function bitPattern(number, bitCount) {
	  return Array.apply(Array, { length: bitCount }).map(function (__, b) {
	    return 1 << bitCount - b - 1 & number ? 1 : 0;
	  }).join('');
	};
	
	// generate array of angles for a number circle of
	// given bitCount.
	var dotArray = function dotArray(encoding, bitCount) {
	  return Array
	  // init array of length 2^bits.
	  .apply(Array, { length: Math.pow(2, bitCount) })
	  // map array to angles
	  .map(function (_, index, _ref) {
	    var length = _ref.length;
	
	    var pattern = bitPattern(index, bitCount);
	    var value = encoding.formatter(pattern);
	    var negative = value.substr(0, 1) === '-';
	
	    return {
	      baseIndex: encoding.baseIndex(pattern),
	      angle: 2 * Math.PI * index / length,
	      value: value,
	      magnitude: encoding.magnitude(pattern),
	      negative: negative,
	      pattern: pattern
	    };
	  });
	};
	
	exports.default = function (encoding$, bitCount$, actions) {
	  var modifierFunction$ = _rx.Observable.merge([actions.selectBit$.map(function (bitIndex) {
	    return function (state) {
	      return { bitCount: state.bitCount, selected: bitIndex };
	    };
	  })]);
	
	  return _rx.Observable.combineLatest(encoding$, bitCount$, function (enc, bitCount) {
	    var encoding = _encodings2.default[enc];
	
	    var dots = dotArray(encoding, bitCount);
	    var dotRadius = 50;
	    var circumference = dotRadius * 4 * Math.max(7, dots.length);
	    var radius = circumference / 2 / Math.PI;
	    var sizeHalf = radius + dotRadius + 100 * Math.max(2, bitCount);
	
	    return modifierFunction$
	    // number of bits to generate the number circle for
	    .startWith({ selected: null })
	    // apply the function
	    .scan(function (state, modifierFunction) {
	      return modifierFunction(state);
	    })
	    // convert number of bit's into array of angles
	    .map(function (_ref2) {
	      var selected = _ref2.selected;
	
	      return {
	        // number of bits
	        bitCount: bitCount,
	        // the dots to draw
	        dots: dots,
	        // the index of the selected dot
	        selected: selected,
	        // the radius of a single dot
	        dotRadius: dotRadius,
	        // the radius of the circle
	        radius: radius,
	        // the angles at which the overflow occurs
	        overflowAngles: encoding.overflowAngles(dots),
	        // the angles at which a warning should be displayed
	        warningAngles: encoding.warningAngles(dots),
	        //
	        negativeClockwise: encoding.negativeClockwise,
	        // the bounding box of the circle
	        bounds: {
	          minX: -sizeHalf,
	          minY: -sizeHalf,
	          maxX: sizeHalf,
	          maxY: sizeHalf
	        }
	      };
	    });
	  }).switch().shareReplay(1);
	};

/***/ },

/***/ 298:
/*!****************************************************!*\
  !*** ./app/components/number-circle/view/index.js ***!
  \****************************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dom = __webpack_require__(/*! @cycle/dom */ 2);
	
	var _hHelper = __webpack_require__(/*! ../../../lib/h-helper */ 7);
	
	__webpack_require__(/*! ./index.styl */ 374);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var renderArc = function renderArc(dots, selected, radius, negativeClockwise) {
	  return (0, _hHelper.IF)(selected !== null, function () {
	    var dot = dots[selected];
	    var zeroDot = dots[dot.baseIndex];
	    var angle = dot.angle;
	    var zeroAngle = zeroDot.angle;
	    var x = Math.sin(angle) * radius;
	    var y = -Math.cos(angle) * radius;
	    var zeroX = Math.sin(zeroAngle) * (radius - 0.1);
	    var zeroY = -Math.cos(zeroAngle) * (radius - 0.1);
	    var mid = Math.abs(angle - zeroAngle) >= Math.PI;
	
	    var largeArc = mid && !dot.negative;
	    var sweep = !negativeClockwise && dot.negative;
	
	    return (0, _dom.svg)('path', {
	      key: 'arc',
	      class: 'selection-arc',
	      d: 'M ' + ~~zeroX + ' ' + ~~zeroY + '\n          A ' + (~~radius - 0.05) + ' ' + (~~radius - 0.05) + ' 0\n          ' + (largeArc ? 1 : 0) + ' ' + (sweep ? 0 : 1) + '\n          ' + x + ' ' + y,
	      fill: 'none',
	      'stroke-width': 10,
	      'marker-end': 'url(#markerArrow)'
	    });
	  });
	};
	
	// the the horizontal offset for text at the given angle
	// (in radians)
	var textAnchor = function textAnchor(angle) {
	  var sin = Math.sin(angle);
	
	  if (sin > 0.01) {
	    return 'start';
	  } else if (sin < -0.01) {
	    return 'end';
	  } else {
	    return 'middle';
	  }
	};
	
	// get the vertical offset for text at the given angle
	// (in radians)
	var baseLine = function baseLine(angle) {
	  var cos = -Math.cos(angle);
	
	  if (cos > 0.01) {
	    return 'text-before-edge';
	  } else if (cos < -0.01) {
	    return 'text-after-edge';
	  } else {
	    return 'central';
	  }
	};
	
	var dotColor = function dotColor(neg, mag) {
	  return neg ? '#' + (100 + Math.floor(mag * 100)).toString(16) + '0000' : '#00' + (100 + Math.floor(mag * 100)).toString(16) + '00';
	};
	
	var renderDot = function renderDot(radius, selected, dot, dotIndex) {
	  return (0, _dom.svg)('g', {
	    key: 'dot-' + dot.pattern,
	    class: 'number-dot' + (selected === dotIndex ? ' state-selected' : ''),
	    attributes: {
	      'data-dot-index': dotIndex
	    }
	  }, [(0, _dom.svg)('circle', {
	    key: 'dot-background',
	    class: 'number-dot-background',
	    cx: ~~(Math.sin(dot.angle) * radius),
	    cy: ~~(-Math.cos(dot.angle) * radius),
	    r: 50,
	    fill: dotColor(dot.negative, dot.magnitude)
	  }), (0, _dom.svg)('text', {
	    key: 'dot-label',
	    class: 'number-dot-label',
	    x: ~~(Math.sin(dot.angle) * radius),
	    y: ~~(-Math.cos(dot.angle) * radius),
	    fill: '#fff',
	    'font-size': '60',
	    'text-anchor': 'middle',
	    'dominant-baseline': 'central'
	  }, dot.value.toString()), (0, _dom.svg)('text', {
	    key: 'dot-pattern',
	    class: 'number-dot-pattern',
	    x: Math.sin(dot.angle) * (radius * 1 + 70),
	    y: -Math.cos(dot.angle) * (radius * 1 + 70),
	    fill: '#000',
	    'font-size': '60',
	    'text-anchor': textAnchor(dot.angle),
	    'dominant-baseline': baseLine(dot.angle)
	  }, dot.pattern.toString())]);
	};
	
	var renderOverflowLine = function renderOverflowLine(angle, radius, dotRadius) {
	  return (0, _dom.svg)('line', {
	    class: 'overflow-line',
	    x1: 0,
	    y1: 0,
	    x2: ~~(Math.sin(angle) * (radius + dotRadius * 3)),
	    y2: ~~(-Math.cos(angle) * (radius + dotRadius * 3)),
	    stroke: 'black',
	    'stroke-width': '10'
	  });
	};
	
	var renderWarning = function renderWarning(angle, radius, dotRadius) {
	  var x = Math.sin(angle) * (radius + 1.5 * dotRadius);
	  var y = -Math.cos(angle) * (radius + 1.5 * dotRadius);
	  var xInner = Math.sin(angle) * (radius - 1.5 * dotRadius);
	  var yInner = -Math.cos(angle) * (radius - 1.5 * dotRadius);
	
	  return (0, _dom.svg)('g', {
	    class: 'warning'
	  }, [(0, _dom.svg)('line', {
	    class: 'warning-line',
	    x1: ~~x,
	    y1: ~~y,
	    x2: ~~xInner,
	    y2: ~~yInner,
	    stroke: 'orange',
	    'stroke-width': '10'
	  }), (0, _dom.svg)('circle', {
	    cx: ~~x,
	    cy: ~~y,
	    r: ~~dotRadius * 0.7,
	    class: 'warning-background',
	    fill: 'orange'
	  }), (0, _dom.svg)('text', {
	    x: ~~x,
	    y: ~~y,
	    'font-size': ~~dotRadius,
	    'text-anchor': 'middle',
	    'dominant-baseline': 'central',
	    class: 'warning-text',
	    fill: 'white'
	  }, '!')]);
	};
	
	// render the dots as svg element
	var render = function render(_ref) {
	  var radius = _ref.radius,
	      dots = _ref.dots,
	      dotRadius = _ref.dotRadius,
	      overflowAngles = _ref.overflowAngles,
	      warningAngles = _ref.warningAngles,
	      selected = _ref.selected,
	      negativeClockwise = _ref.negativeClockwise;
	
	  return (0, _dom.svg)('g', [(0, _dom.svg)('defs', [(0, _dom.svg)('marker', {
	    id: 'markerArrow',
	    markerWidth: 3,
	    markerHeight: 4,
	    refX: 2,
	    refY: 2,
	    orient: 'auto',
	    class: 'arrow-head'
	  }, [(0, _dom.svg)('path', {
	    d: 'M0,0 L0,4 L3,2 L0,0'
	  })])]), (0, _dom.svg)('circle', {
	    class: 'number-circle-circumference',
	    cx: 0,
	    cy: 0,
	    r: ~~radius
	  })].concat(_toConsumableArray(dots.map(function (d, i) {
	    return renderDot(radius, selected, d, i);
	  })), [renderArc(dots, selected, radius - dotRadius * 1.5, negativeClockwise), overflowAngles.map(function (angle) {
	    return renderOverflowLine(angle, radius, dotRadius);
	  }), warningAngles.map(function (angle) {
	    return renderWarning(angle, radius, dotRadius);
	  }), (0, _dom.svg)('circle', {
	    class: 'number-circle-center',
	    cx: 0,
	    cy: 0,
	    r: 10
	  })]));
	};
	
	exports.default = function (state$) {
	  return state$.map(render);
	};

/***/ },

/***/ 374:
/*!******************************************************!*\
  !*** ./app/components/number-circle/view/index.styl ***!
  \******************************************************/
46,

/***/ 380:
/*!********************************************!*\
  !*** ./app/pages/number-circle/index.styl ***!
  \********************************************/
46

});


/** WEBPACK FOOTER **
 ** numberCircle-3cf66522f22be8da0286.js
 **/